<template>
  <div v-cloak class="crowdfunding">
    <!-- 头部banner图 -->
    <div class="swiper"></div>

    <!-- 中间内容 -->
    <div class="container o-h pa-b-40">
      <div class="ma-t-30"><Bread :list="breadList" /></div>

      <div class="ma-t-30">
        <div class="flex f-wrap">
          <div
            v-for="(item, index) in dataList"
            :key="index"
            @click="toDetail(item.Id)"
            class="item-box ma-b-20 c-pointer"
          >
            <img :src="item.Cover" alt="" srcset="" class="item-img" />
            <div class="pa-10">
                <div class="font-bold t-omit-1 fon-20" :title="item.Name">
                {{item.Name}}
            </div>
            <div class="flex f-between  ma-t-10">
                <div class="c-red font-bold">￥{{item.Amount}}</div>
                <div>{{getProgress(item)}}</div>
            </div>
            <div class="progress-box ma-t-5">
                    <div class="progress-line" :style="{'width':getProgress(item)}"></div>
            </div>
            <div class="fon-15  ma-t-5">
                {{item.PayCount}}支持者
            </div>
            </div>
          </div>
        </div>
        <div v-if="dataList.length == 0" class="width100">
          <div class="t-center ma-t-40">
            <img src="../../img/empty.png" alt="" srcset="" width="200" />
            <div class="c-999">暂无数据</div>
          </div>
        </div>
      </div>

      <div class="fy">
        <el-pagination
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page.sync="pageIndex"
          :page-size="16"
          layout="prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@media  (max-width: 768px){
  .item-img{width: 32%;}
  
}

.o-h{
  overflow: hidden;
}
body {
  background: #f5f7fa;
}
.container {
  padding-left: 30px;
  padding-right: 30px;
  background: #fff;
  box-sizing: border-box;
}
.swiper {
  width: 100%;
  height: 314px;
  background-image: url(../../img/cf-bg.png);
  background-size: cover;
  background-position: bottom;
  position: relative;
}
.item-box {
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgb(0 0 0 / 20%);
  border-radius: 6px;
  margin-right: 1%;
  .item-img {
    width: 100%;
    height: 230px;
  }
}
.progress-box{
    width: 100%;
    height: 6px;
    background: rgb(219, 219, 219);
    .progress-line{
        height: 100%;
        background: red;
    }
}
</style>
  <script>
import { getCrowdFundingList } from "../../api.js";
import Bread from "../../components/Bread.vue";

// studycollect
export default {
  name: "crowdfunding",
  components: {Bread},
  data() {
    return {
      activeName: "0",
      kinds: [{ Id: "0", Name: "全部" }],
      totals: 0, //一个分类下的总条数
      pageIndex: 1,
      dataList: [],
      breadList: [{ name: "众筹列表", path: "/crowdfunding/list" }],
    };
  },

  created() {
    // console.log("created----");
    this.getList();
  },

  // 其他页面进来时更新初始数据
  activated() {
    // console.log("909090------");
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);

    next();
  },

  methods: {
    //获取进度
    getProgress(item){
        return (item.GetAmount*100/item.Amount).toFixed(2)+'%'
    },
    getList() {
      let token = localStorage.getItem("AccessToken");
      let data = {
        token: token,
        source: "web",
        pageIndex: this.pageIndex,
        pageSize: 12,
      };
      // console.log(data);
      getCrowdFundingList(data).then((res) => {
        if (res.data.Code == 0) {
          this.dataList = res.data.Data.List;
          this.totals = res.data.Data.TotalCount;
        }
      });
    },
    toDetail(id = 1) {
      //  this.$router.push({
      //   path: "/Img",
      //   query: { id: id },
      // });
      this.$router.push({
        path: "/crowdfunding/detail",
        query: { id: id },
      });
    },

    //点击切换种类
    handleClick() {
      // console.log(tab);
      this.pageIndex = 0;
      this.getList();
    },

    // 当前页改变时触发
    handleCurrentChange(e) {
      this.pageIndex = e - 1;
      this.getList();
    },
  },
};
</script>
  